import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Catalogue from "./pages/Catalogue";
import Inscription from "./pages/Inscription";
import Connexion from "./pages/Connexion";
import Admin from "./pages/Admin";
import SuiviBC from "./pages/SuiviBC";
import ClientOrders from "./pages/ClientOrders";
import IntroSplash from "./components/IntroSplash";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <IntroSplash />}
      <Navbar />
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/suivi/:bid" element={<SuiviBC />} />
          <Route path="/mes-commandes" element={<ClientOrders />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <FloatingWhatsApp />
      <Toaster />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
